<div>
    <p class="sg-heading__h5 text-uppercase">Download our free app</p>

    <div class="mx-3">
        <div class="row">
            <div
                class="col-12 pl-0"
                [ngClass]="{ 'col-sm-8': showList }"
                *ngIf="showList"
            >
                <ul class="list-unstyled list-green">
                    <li>
                        Instantly book sports facilities at a number of
                        Playfinder venues
                    </li>
                    <li>
                        Geo-location and discovery portal - search 16 different
                        sports by location
                    </li>
                    <li>View upcoming bookings in your calendar</li>
                    <li>
                        Available in London, Brighton, Dublin and Manchester
                    </li>
                </ul>
            </div>

            <div
                class="col-12 mb-3 text-center"
                [ngClass]="{ 'col-sm-4': showList }"
            >
                <img
                    src="/ng-assets/phones.png"
                    style="max-width: 140px"
                    alt="Download Playfinder App"
                />
            </div>
        </div>

        <div class="col-12 text-center">
            <a href="{{ trackingTitle | appleLinkPipe }}" target="_blank">
                <img
                    src="/ng-assets/download-app.svg"
                    alt="Download Playfinder App"
                />
            </a>

            <a href="{{ trackingTitle | androidLinkPipe }}" target="_blank">
                <img
                    src="/ng-assets/google-play-badge.svg"
                    class="store-badge"
                    alt="Download Playfinder App"
                />
            </a>
        </div>
    </div>
</div>
